tiz.directive('arrow', function() {
  return {
    scope: {
      direction: "@"
    },
    restrict: 'E',
    template: '<span ng-class="classes()"><svg width="10px" height="10px"><polygon fill="currentColor" points="8.32308264 2 5 5.22785648 1.67691736 2 0.25 3.38602765 5 7.99991178 9.75 3.38602765" /></svg></span>',
    link: function(scope, element, attrs) {
      scope.classes = function() {
        return {
          'arrow--up': scope.direction == 'ASC' || scope.direction == 'up',
          'arrow--down': scope.direction == 'DESC' || scope.direction == 'down',
          'arrow--left': scope.direction == 'left',
          'arrow--right': scope.direction == 'right'
        }
      };
    }
  };
});
